import { useTranslation } from 'react-i18next';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50 relative overflow-hidden">
      <div className="max-w-[1000px] mx-auto">
        <div className="bg-foreground-950 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 relative overflow-hidden">
          <div className="w-full lg:w-[35%] flex-shrink-0">
            <div className="rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Portrait%20of%20a%20confident%20professional%20in%20a%20modern%20coffee%20shop%20with%20exposed%20brick%20walls%2C%20warm%20industrial%20lighting%2C%20genuine%20smile%2C%20stylish%20casual%20blazer%2C%20editorial%20portrait%20with%20bokeh%20background%2C%20authentic%20lifestyle%20moment&width=600&height=750&seq=testimonial-v2-photo&orientation=portrait"
                alt="Customer testimonial"
                className="w-full aspect-[4/5] object-cover object-top rounded-xl"
              />
            </div>
          </div>

          <div className="w-full lg:w-[65%] text-white">
            <div className="text-6xl md:text-7xl text-accent-400 font-heading leading-none opacity-60">"</div>
            <p className="text-base md:text-lg leading-relaxed text-white/90 -mt-4">
              {t('testimonial.quote')}
            </p>
            <div className="mt-6">
              <p className="font-heading text-lg font-semibold text-white">{t('testimonial.name')}</p>
              <p className="text-sm text-white/60">{t('testimonial.role')}</p>
            </div>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-block mt-6 px-6 py-2.5 bg-accent-500 text-foreground-950 text-sm font-medium rounded-full hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('testimonial.cta')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}